import styled, { keyframes } from 'styled-components'

import { Text } from '@/components'

const blink = keyframes`
  from {
    opacity: 1
  }

  to {
    opacity: 0
  }
`

export const TypewriterEffect = styled(Text)`
  background-color: white;
  padding: 0 12px;
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;

  &::after {
    content: '_';
    animation: ${blink} 0.75s infinite;
  }
`
